/**
 * Rider-Waite-Smith Tarot Card Images
 * Self-hosted in /public/tarot/ (public domain, originally from Wikimedia Commons)
 */

const SUIT_FILE_PREFIX: Record<string, string> = {
  wands: 'wands',
  cups: 'cups',
  swords: 'swords',
  pentacles: 'pents',
};

/**
 * Get Rider-Waite card image URL from card data.
 * Returns empty string if no image found.
 */
export function getCardImageUrl(card: { id: number; name: string; suit: string }): string {
  // Major Arcana: ids 0-21
  if (card.suit === 'major' && card.id >= 0 && card.id <= 21) {
    const nn = card.id.toString().padStart(2, '0');
    return `/tarot/major_${nn}.jpg`;
  }

  // Minor Arcana: derive card number from id
  // ids: 22-35 = Wands (Ace-King), 36-49 = Cups, 50-63 = Swords, 64-77 = Pentacles
  if (card.suit !== 'major') {
    const suitStarts: Record<string, number> = {
      wands: 22, cups: 36, swords: 50, pentacles: 64,
    };
    const start = suitStarts[card.suit];
    if (start !== undefined) {
      const cardNumber = card.id - start + 1; // 1=Ace, 14=King
      if (cardNumber >= 1 && cardNumber <= 14) {
        const prefix = SUIT_FILE_PREFIX[card.suit];
        const nn = cardNumber.toString().padStart(2, '0');
        return `/tarot/${prefix}_${nn}.jpg`;
      }
    }
  }

  return '';
}
